import { createSlice } from '@reduxjs/toolkit';
import { setLocalStorage } from '../../helpers/jsHelper';

export const ONBOARDING_STEPS = {
  INDUSTRY: 1,
  PLATFORM: 2,
  COMPANY_SIZE: 3,
  CREATE_TEAM: 4,
  STAY_IN_TOUCH: 5,
}

const getInitialDataOptions = () => {
  return {
    industry: [],
    platform: [],
    companySize: [],
    images: null,
  }
}

const getInitialData = () => {
  return {
    industry: [],
    otherIndustryData: {
      isOtherSelected: null,
      otherDataList: [],
    },
    platform: [],
    otherPlatformData: {
      isOtherSelected: null,
      otherDataList: [],
    },
    companySize: null,
    team: {
      name: null,
      emails: [],
      newName: null,
    }
  }
}

const initialState = {
  dataOption: getInitialDataOptions(),
  currentStep: ONBOARDING_STEPS.INDUSTRY,
  selectedData: getInitialData(),
  user: null,
}

const onBoarding = createSlice({
  name: 'onBoarding',
  initialState,
  reducers: {
    resetState: (state) => {
      return {
        ...initialState
      }
    },
    setDataOptions: (state, { payload }) => {
      state.dataOption = payload
    },
    addDataOption: (state, { payload }) => {
      const { key, value } = payload;
      state.dataOption[key] = value;
    },
    updateDataOption: (state, { payload }) => {
      const { key, value } = payload;
      state.dataOption[key] = value;
    },
    setSelectedData: (state, { payload }) => {
      state.selectedData = payload
    },
    addSelectedData: (state, { payload }) => {
      const { key, value } = payload;
      state.selectedData[key] = value;
    },
    updateSelectedData: (state, { payload }) => {
      const { key, value } = payload;
      state.selectedData[key] = value;
    },
    setCurrentStep: (state, {payload}) => {
      state.currentStep = payload;
      if(payload === ONBOARDING_STEPS.STAY_IN_TOUCH) {
        setLocalStorage('ONBOARDING_STEP', payload);
      }
    },
    setUser: (state, {payload}) => {
      state.user = payload
    },
  },
});

export const onBoardingActions = onBoarding.actions;
export const onBoardingSelector = (state) => state.onBoarding;
export const onBoardingReducer = onBoarding.reducer;
export default onBoardingReducer;

export const selectOnBoardingDataOptions = (state) => state.onBoarding.dataOption;
export const selectOnBoardingDataOptionsByKey = (state, key) => {
  const options = selectOnBoardingDataOptions(state);
  return options[key] || null;
}
export const selectOnBoardingCurrentStep = (state) => state.onBoarding.currentStep;

export const selectOnBoardingSelectedData = (state) => state.onBoarding.selectedData;
export const selectOnBoardingSelectedDataByKey = (state, key) => {
  const selected = selectOnBoardingSelectedData(state);
  return selected[key] || null;
}

export const selectOnBoardingCurrentUser = (state) => state.onBoarding.user;
export const selectUserFirstName = (state) => state.onBoarding.user?.first_name;
export const selectUserOrgName = (state) => state.onBoarding.user?.organization_details?.name;
export const selectIsUserOrgOwner = (state) => state.onBoarding.user?.is_org_owner;